/**
 * Bottom Bar Banner
 * Handles showing/hiding the promotional banner at the bottom of the page
 */

export default function bottomBar() {
  const banner = document.getElementById('bottom-bar-banner');
  if (!banner) return;

  const bannerId = banner.dataset.bannerId;
  const hideHours = parseFloat(banner.dataset.hideHours) || 24;
  const storageKey = 'bottom_bar_dismissed';

  // Check if banner was dismissed
  function isDismissed() {
    try {
      const stored = localStorage.getItem(storageKey);
      if (!stored) return false;

      const data = JSON.parse(stored);

      // If banner ID changed (content changed), show again
      if (data.bannerId !== bannerId) {
        localStorage.removeItem(storageKey);
        return false;
      }

      // Check if hide time has passed
      const now = Date.now();
      if (now > data.expiry) {
        localStorage.removeItem(storageKey);
        return false;
      }

      return true;
    } catch (e) {
      return false;
    }
  }

  // Dismiss banner
  function dismissBanner() {
    const expiry = Date.now() + (hideHours * 60 * 60 * 1000);
    const data = {
      bannerId: bannerId,
      expiry: expiry
    };

    try {
      localStorage.setItem(storageKey, JSON.stringify(data));
    } catch (e) {
      // localStorage may be unavailable
    }

    banner.style.transform = 'translateY(100%)';
    setTimeout(function() {
      banner.style.display = 'none';
    }, 300);
  }

  // Show or hide banner based on localStorage
  function initBanner() {
    if (isDismissed()) {
      banner.style.display = 'none';
    } else {
      banner.style.transform = 'translateY(0)';
    }
  }

  // Listen for close button click
  const closeBtn = banner.querySelector('.bottom-bar__close');
  if (closeBtn) {
    closeBtn.addEventListener('click', dismissBanner);
  }

  // Initialize
  initBanner();
}
